import { LoadingButton } from "@mui/lab";
import { Grid, Button, Typography } from "@mui/material";

import { Children, cloneElement, isValidElement } from "react";

const styles = {
  boxContainer: {
    display: "inline-flex",
    borderRadius: "0.5rem",
    justifyContent: "flex-start",
    flexDirection: "column",
    textAlign: "left",
    padding: "2rem",
    paddingBottom: "1rem",
    minHeight: "200px",
    height: "100%",
    border: "1px solid #0000003b",
    width: "100%",
    background: "white",
    position: "relative",
  },

  innerBoxContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "stretch",
    textAlign: "left",
    alignItems: "center",
    width: "100%",
    height: "100%",
    "& span": {
      flexGrow: "1",
      color: "blue",
    },
  },

  button: {
    width: "100%",
    background: "#1a4079",
    borderRadius: "8px",
    color: "white",
    boxShadow: "0px 3px 5px rgba(0, 0, 0, 0.3)",
    fontSize: "12px",
    padding: "8px 20px",
    "&:hover": {
      opacity: "0.8",
      background: "#1a4079",
    },
  },
};

const DashboardCard = ({
  children,
  title,
  buttonText,
  buttonOnClick,
  iconUrl = null,
  extraButtons = null,
  loading,
}) => {
  const transformedChildren = Children.map(children, (child) => {
    if (isValidElement(child)) {
      const transformedGrandChildren = Children.map(
        child.props.children,
        (grandChild) => {
          if (isValidElement(grandChild)) {
            return cloneElement(grandChild, {
              style: {
                width: "100%",
                fontSize: "14px",
                ...grandChild.props.style,
              },
            });
          }
          return grandChild;
        }
      );
      return cloneElement(
        child,
        { style: { ...styles.innerBoxContainer, ...child.props.style } },
        transformedGrandChildren
      );
    }
    return child;
  });

  return (
    <div style={styles.boxContainer}>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          textAlign: "center",
          alignItems: "center",
          gap: "1rem",
          marginBottom: "2rem",
        }}
      >
        {iconUrl ? (
          <img src={iconUrl} alt="Logo" width="50" height="50" />
        ) : null}

        <Typography color="primary" fontWeight="bold">
          {title}
        </Typography>
      </div>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "stretch",
          gap: "5px",
          flexGrow: "1",
          fontSize: "14px",
        }}
      >
        {transformedChildren}
      </div>
      <Grid
        item
        md={12}
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "flex-end",
          mt: 3,
        }}
      >
        {extraButtons}
        {buttonText ? (
          <LoadingButton
            loading={loading}
            sx={styles.button}
            onClick={buttonOnClick}
          >
            {buttonText}
          </LoadingButton>
        ) : null}
      </Grid>
    </div>
  );
};

export default DashboardCard;
